export default __webpack_public_path__ + "cfc1d3b50047a78c5d5cd94163b52eea.jpg";